import React from "react";

export const ShowcaseMaintenance = () => {
  return (
    <div className={"ShowcaseComingSoon"}>
      <div className={"ShowcaseComingSoon__Content"}>Showcase in maintenance</div>
    </div>
  )
}